<template>
    <div class="myCardsWrap">
        <!-- <nav-bar></nav-bar> -->
        <div class="cardListWrap fc ac">
            <button @click="addVipCard" class="addCard bg_tc white">添加贵宾卡</button>
            <div class="cardItem fc" v-for="item in vipCardList" :key="item.cardno">
                <div class="info fr">
                    <span class="num">1</span>
                    <div class="infoDetail fc ac jc">
                        <p class="cardNo">卡号:<span>{{item.cardno}}</span></p>
                        <p class="balance">
                            剩余金额：
                            <span class="red">{{item.balance/100}}</span>元
                        </p>
                    </div>
                </div>
                <span class="date">有效日期至：{{item.enddate}}</span>
            </div>
        </div>
    </div>
</template>

<script>
import navBar from "../../components/common/navBar.vue";
export default {
    data() {
        return {
            page_no: 0,
            vipCardList: []
        };
    },
    components: {
        navBar
    },
    created() {
        this.getVipCardList();
    },
    methods: {
        addVipCard() {
            this.$router.push("/addVipCard");
        },
        getVipCardList() {
            this.$post({
                method: "member.coupon.vipcard.list",
                auth_code: this.getLocal("auth_code"),
                page_no: this.page_no
            }).then(res => {
                if (res.success) {
                    this.vipCardList = res.data.couponlist;
                }
            });
        }
    }
};
</script>
<style scoped lang="scss">
.myCardsWrap {
    .cardListWrap {
        .addCard {
            width: 214px;
            height: 78px;
            font-size: 28px;
            border-radius: 10px;
            margin: 50px 0;
        }
        .cardItem {
            width: 100%;
            padding: 0 35px;
            box-sizing: border-box;
            margin-bottom: 25px;
            .info {
                background-color: #fff;
                height: 140px;
                border-radius: 15px 15px 0 0;
                .num {
                    font-size: 50px;
                    color:#ff5204;
                    width: 200px;
                    line-height: 140px;
                    text-align: center;
                    border-right: 1px dashed #eee;
                }
                .infoDetail {
                    width: calc(100% - 200px);
                    font-size: 28px;
                    color: #999;
                    .cardNo {
                        margin-bottom: 15px;
                    }
                    .cardNo span {
                        font-size: 32px;
                        color: #333;
                    }
                }
                .balance span {
                    font-size: 32px;
                }
            }
            .date {
                background-color: #f9f9f9;
                height: 60px;
                line-height: 60px;
                padding: 0 20px;
                box-sizing: border-box;
                border-radius: 0 0 15px 15px;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/me/myVipCard.vue